import { render } from "./proposal-details-check.vue?vue&type=template&id=07a8e4c2&scoped=true"
import script from "./proposal-details-check.vue?vue&type=script&lang=js"
export * from "./proposal-details-check.vue?vue&type=script&lang=js"

import "./proposal-details-check.vue?vue&type=style&index=0&id=07a8e4c2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a8e4c2"]])

export default __exports__